export default {
  ENROLL_FOR_PROGRAM: 'ENROLL_FOR_PROGRAM',
  ENROLL_FOR_PROGRAM_SUCCESS: 'ENROLL_FOR_PROGRAM_SUCCESS',
  ENROLL_FOR_PROGRAM_FAILURE: 'ENROLL_FOR_PROGRAM_FAILURE',

  UNENROLL_FROM_PROGRAM: 'UNENROLL_FROM_PROGRAM',
  UNENROLL_FROM_PROGRAM_SUCCESS: 'UNENROLL_FROM_PROGRAM_SUCCESS',
  UNENROLL_FROM_PROGRAM_FAILURE: 'UNENROLL_FROM_PROGRAM_FAILURE',

  FETCH_PROGRAM_DETAILS: 'FETCH_PROGRAM_DETAILS',
  FETCH_PROGRAM_DETAILS_SUCCESS: 'FETCH_PROGRAM_DETAILS_SUCCESS',
  FETCH_PROGRAM_DETAILS_FAILURE: 'FETCH_PROGRAM_DETAILS_FAILURE',

  FETCH_PROGRAM_MODULES: 'FETCH_PROGRAM_MODULES',
  FETCH_PROGRAM_MODULES_SUCCESS: 'FETCH_PROGRAM_MODULES_SUCCESS',
  FETCH_PROGRAM_MODULES_FAILURE: 'FETCH_PROGRAM_MODULES_INFO_FAILURE',

  FETCH_PROGRAM_OVERVIEW_FUNDRAISER: 'FETCH_PROGRAM_OVERVIEW_FUNDRAISER',
  FETCH_PROGRAM_OVERVIEW_FUNDRAISER_SUCCESS: 'FETCH_PROGRAM_OVERVIEW_FUNDRAISER_SUCCESS',
  FETCH_PROGRAM_OVERVIEW_FUNDRAISER_FAILURE: 'FETCH_PROGRAM_OVERVIEW_FUNDRAISER_FAILURE',

  TOGGLE_MODULE_OPEN_STATUS: 'TOGGLE_MODULE_OPEN_STATUS',

  FETCH_PROGRAM_MODULES_ENROLLED: 'FETCH_PROGRAM_MODULES_ENROLLED',
  FETCH_PROGRAM_MODULES_ENROLLED_SUCCESS: 'FETCH_PROGRAM_MODULES_ENROLLED_SUCCESS',
  FETCH_PROGRAM_MODULES_ENROLLED_FAILURE: 'FETCH_PROGRAM_MODULES_ENROLLED_FAILURE',

  FETCH_PROGRAM_MODULES_UNENROLLED: 'FETCH_PROGRAM_MODULES_UNENROLLED',
  FETCH_PROGRAM_MODULES_UNENROLLED_SUCCESS: 'FETCH_PROGRAM_MODULES_UNENROLLED_SUCCESS',
  FETCH_PROGRAM_MODULES_UNENROLLED_FAILURE: 'FETCH_PROGRAM_MODULES_UNENROLLED_FAILURE',

  FETCH_ENROLLED_PROGRAMS: 'FETCH_ENROLLED_PROGRAMS',
  FETCH_ENROLLED_PROGRAMS_SUCCESS: 'FETCH_ENROLLED_PROGRAMS_SUCCESS',
  FETCH_ENROLLED_PROGRAMS_FAILURE: 'FETCH_ENROLLED_PROGRAMS_FAILURE',

  SHOW_PROGRAM_ABOUT: 'SHOW_PROGRAM_ABOUT',

  TOGGLE_ENROLL_ICON_HOVER: 'TOGGLE_ENROLL_ICON_HOVER',

  FETCH_PROGRAM_USER_PROGRESS: 'FETCH_PROGRAM_USER_PROGRESS',
  FETCH_PROGRAM_USER_PROGRESS_SUCCESS: 'FETCH_PROGRAM_USER_PROGRESS_SUCCESS',
  FETCH_PROGRAM_USER_PROGRESS_FAILURE: 'FETCH_PROGRAM_USER_PROGRESS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/programs/overview/actionTypes.js